import { render, staticRenderFns } from "./ReusePotentialIndexCrossSections.vue?vue&type=template&id=0a368b54&scoped=true"
import script from "./ReusePotentialIndexCrossSections.vue?vue&type=script&lang=js"
export * from "./ReusePotentialIndexCrossSections.vue?vue&type=script&lang=js"
import style0 from "./ReusePotentialIndexCrossSections.vue?vue&type=style&index=0&id=0a368b54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a368b54",
  null
  
)

export default component.exports